





















import { Component, Vue, Watch } from 'vue-property-decorator';
import SpecOutBrowseContacts from '@/components/SpecOutContacts/SpecOutBrowseContacts.vue';
import SpecOutContacts from '@/components/SpecOutContacts/SpecOutContacts.vue';
import { SpecOutDetailsModule } from '@/store/modules/specOutDetails';
import GiganautVue from '@/components/Shared/GiganautVue';

@Component({
  name: 'SpecOutContactsTab',
  components: { SpecOutBrowseContacts, SpecOutContacts }}
  )
export default class extends GiganautVue {

    currentTabIndex = -1;

    async beforeMount() {
		await SpecOutDetailsModule.getSpecOutContacts();
		await SpecOutDetailsModule.browseContactSearch();
        if (this.specOutContacts.length > 0) {
            this.currentTabIndex = 1;
        }
	}

    get loading() {
        return SpecOutDetailsModule.loadingContacts;
    }

	get currentSpecOut() {
		return SpecOutDetailsModule.currentSpecOut;
    }

    get specOutContacts() {
        return SpecOutDetailsModule.specOutContacts;
    }
}
